module.exports = __webpack_public_path__ + "img/img5.bbe8bb46.svg";